<template>
  <div class="lesson">
    <h1 v-if="lesson.title">{{ lesson.title }}</h1>
    <iframe @load="load" :src="lesson.url" frameborder="0" ></iframe>
    <iframe v-if="!isLoading && !lesson.url" frameborder="0">{{ $t("ONLINE_TRAINING.MESSAGE.LOADING_CONTENT") }}</iframe>
    <b-loading :is-full-page="isLoading" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading : true
    }
  },
  computed: {
    ...mapGetters(["lesson"])
  },
  methods:  {
    load(){
      this.isLoading = false
    }
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  background: white;
  iframe {
    width: 100%;
    height: 100vh;
  }

  h1 {
    padding: 10px 20px;
    font-weight: 500;
  }
}
</style>
